(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Fist = Lfl.Fist || {};

    (function (Fist, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Fist, 'PhotoswipeInitializer')) {
            return;
        }

        /*
         |===============================================================================================================
         | Class definition
         |===============================================================================================================
         */

        /**
         *
         * @memberOf Lfl.Fist
         */
        Lfl.Fist.PhotoswipeInitializer = Fist.PhotoswipeInitializer || {};

        (function (PhotoswipeInitializer, $, undefined) {

            var galleryListeners = [];

            var openGallery;

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             * @param gallerySelector
             * @param useNotificationThumbnail Set to true if using notification excerpt which only shows first 5 photos.
             */
            PhotoswipeInitializer.initialize = function (gallerySelector, useNotificationThumbnail = false) {
                const isMobileScreen = MobileCallbacks.isMobile()
                    || Math.min(window.screen.width, window.screen.height) < 768
                    || navigator.userAgent.indexOf('Mobi') > -1;

                const arrowPrev = '<svg aria-hidden="true" class="pswp__icn" height="24px" viewBox="0 0 24 24" width="24px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.51 3.87L15.73 2.1 5.84 12l9.9 9.9 1.77-1.77L9.38 12l8.13-8.13z"/></svg>';
                const close = '<svg aria-hidden="true" class="pswp__icn" height="24px" viewBox="0 0 24 24" width="24px"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>';

                const lightbox = new PhotoSwipeLightbox({
                    gallery: gallerySelector,
                    children: 'a[data-lfl-img]',
                    pswpModule: PhotoSwipe,
                    loop: false,
                    zoom: false,
                    imageClickAction: () => {
                        togglePhotoswipe(lightbox);
                    },
                    tapAction: () => {
                        togglePhotoswipe(lightbox);
                    },
                    doubleTapAction: 'zoom',
                    arrowPrevSVG: arrowPrev,
                    arrowNextSVG: arrowPrev,
                    closeSVG: close,
                    bgOpacity: 1,
                    paddingFn: (viewportSize) => {
                        return {
                            top: viewportSize.x < 1601 ? 0 : 70,
                            bottom: viewportSize.x < 1601 ? 0 : 70,
                            left: viewportSize.x < 1601 ? 0 : 80,
                            right: viewportSize.x < 1601 ? 0 : 80,
                        };
                    },
                    errorMsg: Lfl.Lang.get('messages.image_not_found')
                });

                lightbox.on('afterInit', () => {
                    openGallery = lightbox;
                    onPhotoswipeOpen(openGallery);
                });

                lightbox.on('close', () => {
                    onPhotoswipeClosed();
                    openGallery = null;
                });

                lightbox.addFilter('thumbEl', (thumbnail, itemData, index) => {
                    if (useNotificationThumbnail && index > 4) {
                        return $(thumbnail)
                            .closest('.photoswipe-thumbnails')
                            .find('.image-list-more')
                            .first()
                            .siblings('img')
                            .get(0);
                    }

                    return thumbnail;
                });

                lightbox.on('uiRegister', function () {
                    lightbox.pswp.ui.registerElement({
                        name: 'download-button',
                        order: 8,
                        isButton: true,
                        tagName: 'a',

                        html: '<svg aria-hidden="true" class="pswp__icn" height="24px" viewBox="0 0 24 24" width="24px"><g><rect fill="none" height="24" width="24"/></g><g><path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z"/></g></svg>',

                        onInit: (el, pswp) => {
                            el.setAttribute('download', '');
                            el.setAttribute('rel', 'noopener');

                            pswp.on('change', () => {
                                el.href = $(pswp.currSlide.data.element).find('img').data('lfl-download-url');
                            });
                        }
                    });

                    lightbox.pswp.ui.registerElement({
                        name: 'custom-caption',
                        order: 9,
                        isButton: false,
                        appendTo: 'root',
                        html: 'Caption text',
                        onInit: (el, pswp) => {
                            pswp.on('change', () => {
                                const currSlideElement = pswp.currSlide.data.element;
                                let captionHTML = '';
                                if (currSlideElement) {
                                    const sharedIn = $(currSlideElement).find('img').data('lfl-shared-in');
                                    const sharedAt = $(currSlideElement).find('img').data('lfl-shared-at');
                                    const sharedWith = $(currSlideElement).find('img').data('lfl-shared-with')
                                    captionHTML = '<div class="caption-row shared-in">' + sharedIn + '</div>'
                                        + '<div class="caption-row">' + sharedAt + '<span class="dot">&sdot;</span>' + sharedWith + '</div>';
                                }
                                el.innerHTML = captionHTML || '';
                            });
                        }
                    });
                });

                /* Adjust background closing animation to viewing mode - light vs. dark */
                lightbox.on('closingAnimationStart', () => {
                    const bgColor = $('.pswp--open').hasClass('pswp--ui-visible') ? '#fff' : '#000';

                    $('.pswp__bg').css('background-color', bgColor);
                });

                lightbox.init();
            };

            PhotoswipeInitializer.onGalleryOpen = function (listener) {
                return galleryListeners.push(listener);
            };

            PhotoswipeInitializer.getGallery = function () {
                return openGallery;
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */

            function onPhotoswipeOpen(gallery) {
                Lfl.Mobile.Sender.onPhotoswipeOpen();
                notifyGalleryListeners(gallery);
            }

            function onPhotoswipeClosed() {
                Lfl.Mobile.Sender.onPhotoswipeClosed();
            }

            function notifyGalleryListeners(gallery) {
                _.each(galleryListeners, function (listener) {
                    listener.apply(null, [gallery]);
                });
            }

            function togglePhotoswipe(lightbox) {
                Lfl.Mobile.Sender.onPhotoswipeFocus(lightbox.pswp.element?.classList.contains('pswp--ui-visible'));
                lightbox.pswp.element?.classList.toggle('pswp--ui-visible');
            }
        }(Fist.PhotoswipeInitializer, jQuery));
    }(Lfl.Fist, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
